import { render, staticRenderFns } from "./CurrentYear.vue?vue&type=template&id=ba48287c&"
import script from "./CurrentYear.vue?vue&type=script&lang=js&"
export * from "./CurrentYear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba48287c')) {
      api.createRecord('ba48287c', component.options)
    } else {
      api.reload('ba48287c', component.options)
    }
    module.hot.accept("./CurrentYear.vue?vue&type=template&id=ba48287c&", function () {
      api.rerender('ba48287c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wvzD47c4x4si/JS/comp/CurrentYear.vue"
export default component.exports